module.exports = __webpack_public_path__ + "img/doc_juan.d14ad212.png";